/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Inventory = "inventory",
    Puzzle = "puzzle",
};
